import {
  Megaphone,
  PenLine,
  Search,
  Palette,
  Lightbulb,
  Users,
  Mail,
  TrendingUp,
  Globe,
} from "lucide-react";

const services = [
  {
    icon: Megaphone,
    title: "Social Media Marketing",
    text: "Full-funnel social — strategy, content calendars, community management, and reels that actually convert.",
  },
  {
    icon: PenLine,
    title: "Content Writing",
    text: "Captions, blogs, scripts and email copy written in your voice — built for resonance and reach.",
  },
  {
    icon: Search,
    title: "SEO",
    text: "On-page, technical and content SEO that gets your brand discovered by the people already searching.",
  },
  {
    icon: Palette,
    title: "Graphic Designing",
    text: "Scroll-stopping creatives — feed designs, carousels, and brand kits that live on-brand everywhere.",
  },
  {
    icon: Lightbulb,
    title: "Brand Strategy",
    text: "Positioning, voice, and visual identity systems that make your brand instantly recognizable.",
  },
  {
    icon: Users,
    title: "Influencer Marketing",
    text: "Curated creator collaborations and end-to-end campaign execution with measurable ROI.",
  },
  {
    icon: Mail,
    title: "Email Marketing",
    text: "Newsletters, flows, and lifecycle campaigns that nurture leads and drive repeat revenue.",
  },
  {
    icon: TrendingUp,
    title: "Performance Ads",
    text: "Meta & Google paid campaigns engineered for return — creative testing, retargeting, and scale.",
  },
  {
    icon: Globe,
    title: "Website Design",
    text: "High-converting landing pages and brand sites — fast, refined, and conversion-led.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <div className="eyebrow mb-5" data-testid="services-eyebrow">
              — What We Do
            </div>
            <h2
              className="font-display text-4xl sm:text-5xl lg:text-6xl text-charcoal leading-[1.05]"
              data-testid="services-heading"
            >
              Services built to{" "}
              <span className="italic text-lilac">grow</span> your brand.
            </h2>
          </div>
          <p
            className="text-charcoal/70 max-w-md text-base leading-relaxed"
            data-testid="services-subtext"
          >
            One studio, every channel. We plug in as your creative & growth
            partner — covering everything from the first idea to the final
            metric.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((s, idx) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                className="service-card"
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]/g, "-")}`}
              >
                <div className="flex items-center justify-between mb-7">
                  <div className="icon-wrap">
                    <Icon size={24} strokeWidth={1.6} />
                  </div>
                  <span className="font-display italic text-lilac/70 text-sm">
                    0{idx + 1}
                  </span>
                </div>
                <h3 className="font-display text-2xl text-charcoal leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-charcoal/65 leading-relaxed">
                  {s.text}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
